import React, { useEffect, useState } from 'react';
import { Button } from '..';
import {
  limitTextMaxCharater,
  formatDateV2,
  formatSecsDuration,
  getInitial,
} from '../../utils';

import icNotif from '../../assets/ic-notif.svg';
import icDate from '../../assets/ic-date.svg';
import icClock from '../../assets/ic-clock.svg';
import icInfo from '../../assets/ic-info.svg';
import remindCheckIcn from '../../assets/following-check.svg';

import MediaPlayer from '../MediaPlayer/MediaPlayer';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPlaylistItems,
  setUpcomingLiveshowReminder,
  getCarouselPlaylistItems,
} from '../../redux/actions/playlist';
import { getMediaInfo } from '../../redux/actions/media';
import { useHistory } from 'react-router-dom';
import { authPopup } from '../../redux/actions/auth';

import { playlistCarouselId } from '../../constants';

const ContentLiveDetailMiddle = ({ item, checkBlockUnblock }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [playVideo, setPlayVideo] = useState(false);
  const [mediaDetail, setMediaDetail] = useState();
  const { token } = useSelector((state) => state.auth);
  const perPage = 10;
  const page = 1;

  useEffect(() => {
    const getEpisode = async () => {
      const detailData = await dispatch(getMediaInfo(item.id, item.type));

      if (detailData && detailData.items && detailData.items.length) {
        const mediaId = detailData.items[0].id;
        const episodes = await dispatch(getPlaylistItems(mediaId, 1, 10));

        setMediaDetail(episodes.data[0]);
      }
    };

    if (item.type === 'series') {
      getEpisode();
    } else {
      setMediaDetail(item);
    }
  }, [dispatch, item]);

  const handleClickRemind = async (event) => {
    event.stopPropagation();

    const isBlockUser = await checkBlockUnblock(item);
    if (isBlockUser) return;
    let isSetReminder = true;

    if (!token) {
      return dispatch(authPopup.show());
    }

    if (item.remind) {
      isSetReminder = false;
    }
    const res = await dispatch(
      setUpcomingLiveshowReminder(item.id, isSetReminder)
    );
    if (res) {
      dispatch(
        getCarouselPlaylistItems(playlistCarouselId, page, perPage, 'upcoming')
      );
    }
  };

  const onNavigatePublicProfile = (e) => {
    e.stopPropagation();
    history.push(`/profile/${item?.profile?.id}`);
  };
  return (
    <>
      <div className='item-detail-upcoming'>
        <span
          className='profile profilesection'
          onClick={onNavigatePublicProfile}
        >
          {item?.profile?.avatar ? (
            <img src={item.profile.avatar} alt='avatar' className='avatar' />
          ) : (
            <div className='avatar'>{getInitial(item.profile.name)}</div>
          )}
          <span style={{ color: '#FFFFFF' }}>{item?.profile?.name}</span>
        </span>

        <div className='title-banner-middle'>
          {limitTextMaxCharater(item.title, 50)}
        </div>
        <div className='content-details'>
          <img src={icDate} alt='icon' width={16} height={16} />
          <span className='date'>{formatDateV2(item.startedAt)}</span>
          <img src={icClock} alt='icon' width={16} height={16} />
          <span className='time'>
            {formatSecsDuration(item.startedAt / 1000, {
              format: 'hh mm',
              delimiter: ':',
            })}
          </span>
        </div>
        <span className='carousel-description-middle'>{item?.description}</span>
        <div className='content-actions'>
          <Button
            icon={item.remind ? remindCheckIcn : icNotif}
            iconStyle={{
              width: 40,
              height: 40,
              backgroundColor: item.remind ? '#1C1C1C' : '#E15A33',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
            }}
            style={{
              fontWeight: 600,
              width: '149px',
              height: '40px',
              background: item.remind ? '#1C1C1C' : '#E15A33',
              borderRadius: '1000px',
            }}
            shape='rounded'
            fontSize={item.remind ? 14 : 16}
            size='large'
            onClick={handleClickRemind}
          >
            {item.remind ? <>Reminder ON</> : <>Remind Me</>}
          </Button>
          <Button
            icon={icInfo}
            iconStyle={{
              width: 40,
              height: 40,
              backgroundColor: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              aspectRatio: '1/1',
            }}
            style={{
              fontWeight: 600,
            }}
            type='text'
            fontSize={16}
            size='large'
          >
            More Info
          </Button>
        </div>
      </div>

      {playVideo && mediaDetail && (
        <MediaPlayer
          mediaType={mediaDetail.type}
          mediaId={mediaDetail.id}
          autoPlay={true}
          onClose={() => setPlayVideo(false)}
        />
      )}
    </>
  );
};

export default ContentLiveDetailMiddle;
